import { render } from "./HeaderEditor.vue?vue&type=template&id=0f188f5d&scoped=true"
import script from "./HeaderEditor.vue?vue&type=script&lang=js"
export * from "./HeaderEditor.vue?vue&type=script&lang=js"

import "./HeaderEditor.vue?vue&type=style&index=0&id=0f188f5d&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f188f5d"]])

export default __exports__